module.exports = __webpack_public_path__ + "media/images/gift-7b32db14d5d022c7746c32b716aa6503.png";